import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { AuthHeading, BackButton } from 'view/components';
import { AuthHeadingImageTypeEnums } from 'view/pages/auth/helpers';
import { AuthFormsFooter, CheckOrVerifyEmail } from 'view/pages/auth/components';
import { useResendCodeTimer } from 'view/pages/auth/hooks/useResendCodeTimer';
import { useContextSelector as useCS } from 'use-context-selector';
import { useResendEmail } from 'view/pages/auth/hooks/useResendEmail';
import * as CS from 'view/pages/auth/commonStyled';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const { remainingTimeToSendCode, setRemainingTimeToSendCode } = useResendCodeTimer();
  const currentEmail: string = useCS(GlobalConfigContext, globalConfigSelectors.currentEmail);

  const { send } = useResendEmail();

  useEffect(() => {
    if (!currentEmail) {
      navigate('/auth/onboarding', { replace: true });
    }
  }, [currentEmail]);

  return (
    <CS.Wrapper>
      <CS.BackButtonBox>
        <BackButton text="Back to Sign Up" fallbackUrl="/auth/registration" />
      </CS.BackButtonBox>
      <CS.AuthMainBox component="section">
        <AuthHeading title="Verify your email" imageType={AuthHeadingImageTypeEnums.CIRCLE} />
        <CS.FormWrapper component="section">
          <CS.FormWrapperMain>
            <CheckOrVerifyEmail
              title="We’ ve sent a verification link to"
              currentEmail={currentEmail || ''}
              subtitle={
                'Please check your email and click on verification button \n to complete registration.'
              }
              description="The link will expire in 24 hours."
            />
          </CS.FormWrapperMain>
          <AuthFormsFooter
            title="Don’t receive the email?"
            hrefText="Resend"
            remainingTimeToSendCode={remainingTimeToSendCode}
            setRemainingTimeToSendCode={setRemainingTimeToSendCode}
            send={send}
          />
        </CS.FormWrapper>
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default VerifyEmailPage;
